import { HelpCircle } from 'lucide-react';
import { AgnesCard, AgnesCardContent, AgnesPageHeader } from '@agnes/ui';
import { NeoAssistCentral } from '@/components/NeoAssistCentral';

const NEOASSIST_ON = import.meta.env.VITE_ENABLE_NEOASSIST === 'true';

export default function PageCentralAjuda() {
  return (
    <>
      <AgnesPageHeader
        icon={<HelpCircle />}
        title="Central de Relacionamento"
        subtitle="Fale conosco"
        breadcrumbs={[{ label: 'Home', href: '/home' }, { label: 'Central de Relacionamento' }]}
      />
      {NEOASSIST_ON ? (
        <NeoAssistCentral />
      ) : (
        <AgnesCard>
          <AgnesCardContent>
            <p className="text-agnes-text-muted" data-qa="central-ajuda-indisponivel">
              Atendimento indisponível no momento. Tente novamente mais tarde.
            </p>
          </AgnesCardContent>
        </AgnesCard>
      )}
    </>
  );
}
